import React from "react";
import { ContentSection } from "sprint-common-web";

import { OriginatorsDataProvider } from "../../../../../../common/data/lookup-data-providers/OriginatorsDataProvider";
import { FileRecordDetails } from "../../../../../common/file-record-details/FileRecordDetails";
import { FileRecordLibraryView } from "../../../../../common/file-record-details/library/FileRecordLibraryView";

interface FileRecordLibrarySectionProps {
    fileRecordDetails: FileRecordDetails;
    isFileRecordDetailsLoading: boolean;
}

export const FileRecordLibrarySection = ({
    fileRecordDetails,
    isFileRecordDetailsLoading
}: FileRecordLibrarySectionProps): JSX.Element => {
    return (
        <OriginatorsDataProvider>
            <ContentSection
                header="File record library"
                testId="library-content-section"
                isLoading={isFileRecordDetailsLoading}
                style={{ height: 350 }}
            >
                <FileRecordLibraryView fileRecordDetails={fileRecordDetails} />
            </ContentSection>
        </OriginatorsDataProvider>
    );
};
